import Alba from "@assets/animations/alba.json";
import Beavy from "@assets/animations/beavy.json";
import Bunny from "@assets/animations/bunny.json";
import Cato from "@assets/animations/cato.json";
import Dino from "@assets/animations/dino.json";
import Dragy from "@assets/animations/dragy.json";
import Froga from "@assets/animations/froga.json";
import Kito from "@assets/animations/kito.json";
import Packo from "@assets/animations/packo.json";
import Pingo from "@assets/animations/pingo.json";
import Rufy from "@assets/animations/rufy.json";
import Solo from "@assets/animations/solo.json";
import Uni from "@assets/animations/uni.json";
import alba from "@assets/gif/alba.gif";
import beavy from "@assets/gif/beavy.gif";
import bunny from "@assets/gif/bunny.gif";
import cato from "@assets/gif/cato.gif";
import dino from "@assets/gif/dino.gif";
import dragy from "@assets/gif/dragy.gif";
import froga from "@assets/gif/froga.gif";
import kito from "@assets/gif/kito.gif";
import packo from "@assets/gif/packo.gif";
import pingo from "@assets/gif/pingo.gif";
import rufy from "@assets/gif/rufy.gif";
import solo from "@assets/gif/solo.gif";
import uni from "@assets/gif/uni.gif";

import { CharactersConfig } from "@typings/global.types";

export const CHARACTERS: CharactersConfig = {
  packo: {
    lottieFile: Packo,
    gif: packo,
    timing: {
      inaction: [0, 238],
      bite: [239, 252],
      jump: [251, 267],
      error: [268, 291],
    },
  },
  cato: {
    lottieFile: Cato,
    gif: cato,
    timing: {
      inaction: [0, 238],
      bite: [239, 250],
      jump: [251, 267],
      error: [268, 291],
    },
  },
  froga: {
    lottieFile: Froga,
    gif: froga,
    timing: {
      inaction: [0, 238],
      bite: [239, 250],
      jump: [251, 267],
      error: [268, 291],
    },
  },
  dragy: {
    lottieFile: Dragy,
    gif: dragy,
    timing: {
      inaction: [0, 238],
      bite: [239, 250],
      jump: [251, 267],
      error: [268, 291],
    },
  },
  alba: {
    lottieFile: Alba,
    gif: alba,
    timing: {
      inaction: [0, 238],
      bite: [239, 250],
      jump: [251, 267],
      error: [268, 292],
    },
  },
  pingo: {
    lottieFile: Pingo,
    gif: pingo,
    timing: {
      inaction: [0, 238],
      bite: [239, 250],
      jump: [251, 267],
      error: [268, 292],
    },
  },
  kito: {
    lottieFile: Kito,
    gif: kito,
    timing: {
      inaction: [0, 238],
      bite: [239, 250],
      jump: [251, 267],
      error: [268, 292],
    },
  },
  uni: {
    lottieFile: Uni,
    gif: uni,
    timing: {
      inaction: [0, 238],
      bite: [239, 250],
      jump: [251, 267],
      error: [268, 292],
    },
  },
  solo: {
    lottieFile: Solo,
    gif: solo,
    timing: {
      inaction: [0, 238],
      bite: [239, 252],
      jump: [251, 267],
      error: [268, 291],
    },
  },
  rufy: {
    lottieFile: Rufy,
    gif: rufy,
    timing: {
      inaction: [0, 238],
      bite: [239, 252],
      jump: [251, 267],
      error: [268, 291],
    },
  },
  beavy: {
    lottieFile: Beavy,
    gif: beavy,
    timing: {
      inaction: [0, 238],
      bite: [239, 252],
      jump: [251, 267],
      error: [268, 292],
    },
  },
  bunny: {
    lottieFile: Bunny,
    gif: bunny,
    timing: {
      inaction: [0, 238],
      bite: [239, 252],
      jump: [251, 267],
      error: [268, 291],
    },
  },
  dino: {
    lottieFile: Dino,
    gif: dino,
    timing: {
      inaction: [0, 238],
      bite: [239, 252],
      jump: [251, 267],
      error: [268, 291],
    },
  },
};
